const MULTI_PLATFORM_ROUTES = [
  {
    path: 'multi-platform/sale-plan',
    name: 'MultiPlatformSalePlan',
    component: () => import('@/views/multi-platform/sale-plan/index'),
    meta: {
      title: '发货计划单',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'multi-inventory-allocation',
    name: 'MultiInventoryAllocation',
    component: () => import('@/views/multi-platform/inventory-allocation'),
    meta: {
      title: '库存调拨',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'multi-platform/outbound-management',
    name: 'MultiPlatformOutboundManagement',
    component: () => import('@/views/multi-platform/outbound-management'),
    meta: {
      title: '出库管理',
      icon: '',
      keepAlive: true,
    },
  },
]
export default MULTI_PLATFORM_ROUTES
